import { computed } from 'vue';
import State from '@/state/State';

export default function useProductAvailability() {
  const appFeatures = computed(() => State.state.company?.properties?.app_features || {});

  return {
    isCoachEnabled: computed(
      () => appFeatures.value.coach_v2_enabled === true || appFeatures.value.coach_v3_enabled === true,
    ),
    isBudgetEnabled: computed(() => appFeatures.value.open_banking_version === 'v2'),
    isRewardsEnabled: computed(() => ['v2', 'v1'].includes(appFeatures.value.discounts_version)),
    isSdlEnabled: computed(() => appFeatures.value.sdl_enabled === true),
    isBuildEnabled: computed(() =>
      ['workplace_savings', 'legacy_build'].includes(appFeatures.value.savings_account_version),
    ),
    // Pension find-&-combine (SIPP) lives behind the same flag the app and
    // backend gate the pension journey on.
    isPensionFindCombineEnabled: computed(() =>
      ['v1', 'v2', 'v3', 'v4'].includes(appFeatures.value.pension_sipp_account_version),
    ),
  };
}
